import { skipToken } from "@reduxjs/toolkit/query";
import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useGetPurchaseBannedQuery } from "redux/apis";

const PURCHASE_BANNED_POLLING_INTERVAL = 60 * 60 * 1000;

const useLoadPurchaseBanned = () => {
	const { authToken, userTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();

	const isChargebackWarningEnabled = isFeatureFlagEnabled(
		FeaturesFlags.CHARGEBACK_REFUND_FILTER
	);
	const shouldFetchPurchaseBanned =
		isChargebackWarningEnabled && !!authToken?.value && !!userTracker;
	const purchaseBannedQueryArg = shouldFetchPurchaseBanned
		? userTracker.id
		: skipToken;

	const result = useGetPurchaseBannedQuery(purchaseBannedQueryArg, {
		pollingInterval: PURCHASE_BANNED_POLLING_INTERVAL
	});

	return result;
};

export default useLoadPurchaseBanned;
